'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FormHiddenField = _react2['default'].createClass({
    displayName: 'FormHiddenField',


    propTypes: {
        'name': _react2['default'].PropTypes.string,
        'value': _react2['default'].PropTypes.string
    },

    render: function render() {
        // Cannot pass null to React input fields. Either pass in undefined for
        // uncontrolled components or an empty string for controlled components
        var value = this.props.value || undefined;

        return _react2['default'].createElement('input', { type: 'hidden', name: this.props.name, value: value });
    }
});

var FormField = _react2['default'].createClass({
    displayName: 'FormField',


    propTypes: {
        'type': _react2['default'].PropTypes.string.isRequired,
        'name': _react2['default'].PropTypes.string.isRequired,
        'value': _react2['default'].PropTypes.string,
        'attributes': _react2['default'].PropTypes.object,
        'options': _react2['default'].PropTypes.object
    },

    // Populates <option> children for a select element
    // Assumes that the data coming from Symfony is formatted as either:
    // type 'select': [value,value,value] (array index is value)
    // type 'hfwidgetformchoice': [{ value: value, label: label},...]
    // Use the latter when you need to preserve the ordering of the list
    generateSelectOptions: function generateSelectOptions() {
        var options = [];
        var choices = void 0,
            choicesAsOrderedObjects = void 0;
        if (this.props.type === 'hfwidgetformchoice') {
            choices = this.props.options.ordered_choices;
            choicesAsOrderedObjects = true;
        } else {
            choices = this.props.options.choices;
        }

        if (choices) {
            options = choices.map(function (item, index) {
                var value = void 0,
                    label = void 0;
                if (choicesAsOrderedObjects) {
                    value = item.value;
                    label = item.label;
                } else {
                    value = index;
                    label = item;
                }

                return _react2['default'].createElement(
                    'option',
                    { key: 'option-value-' + index, value: value },
                    label
                );
            });
        }
        return options;
    },
    render: function render() {

        var tag;
        var children;
        var attrs = this.props.attributes || {};

        switch (this.props.type) {

            case 'input':
                attrs.type = 'text';
                // Cannot pass null to React input fields. Either pass in undefined for
                // uncontrolled components or an empty string for controlled components
                attrs.value = attrs.value || this.props.value || undefined;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'inputcheckbox':
                attrs.type = 'checkbox';
                attrs.checked = attrs.checked || (this.props.value ? 'checked' : undefined);
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'inputfile':
                attrs.type = 'file';
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'inputpassword':
                attrs.type = 'password';
                // Cannot pass null to React input fields. Either pass in undefined for
                // uncontrolled components or an empty string for controlled components
                attrs.value = attrs.value || this.props.value || undefined;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'select':
            case 'hfwidgetformchoice':
            case 'selectmany':
                attrs.value = attrs.value || this.props.value || undefined;
                attrs.name = this.props.name;
                if (this.props.type == 'selectmany') {
                    attrs.multiple = 'multiple';
                }
                children = this.generateSelectOptions();
                tag = _react2['default'].DOM.select;
                break;

            case 'selectradio':
                attrs.type = 'radio';
                attrs.value = attrs.value || this.props.value;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.input;
                break;

            case 'textarea':
                // Cannot pass null to React textarea fields. Either pass in
                // undefined for uncontrolled components or an empty string for
                // controlled components
                attrs.value = attrs.value || this.props.value || undefined;
                attrs.name = this.props.name;
                tag = _react2['default'].DOM.textarea;
                break;

            default:
                throw new Error('Form field type not supported: ' + this.props.type);

        }

        return tag(attrs, children); // Tag function is selected from ReactDOM above
    }
});

var BaseFormSpecs = {

    displayName: 'CustomForm',

    propTypes: {
        'name': _react2['default'].PropTypes.string, // Form name
        'method': _react2['default'].PropTypes.string, // Form method (POST, GET, ...)
        'action': _react2['default'].PropTypes.string, // Form target
        'fields': _react2['default'].PropTypes.array, // name => field info
        'values': _react2['default'].PropTypes.object, // name => value
        'errors': _react2['default'].PropTypes.object, // { 'global': [...], 'named': { name => message } }
        'namespace': _react2['default'].PropTypes.string // Namespace pattern for field names
    },

    getInitialState: function getInitialState() {
        return {
            'errors': this.props.errors,
            'hasErrors': this.props.errors && (this.props.errors.global || this.props.errors.named)
        };
    },
    getFieldName: function getFieldName(field) {
        if (field) {
            var token = (field.options ? field.options.id_format : undefined) || '%s';
            return this.props.namespace.replace(token, field.name);
        }
    },
    getFieldValue: function getFieldValue(field) {
        var v = this.props.values ? this.props.values[field.name] : undefined;
        if (v === undefined && field['default']) {
            v = field['default'];
        }
        return v;
    },


    /**
        Grabs the user-entered value using the React refs for the field
        @param string fieldname - the non-namespaced name of the field
        @return mixed | undefined;
    */
    getDOMValueForFieldname: function getDOMValueForFieldname(fieldname) {

        var field = void 0,
            value = void 0;

        var filtered = this.props.fields.filter(function (field) {
            return field.name === fieldname;
        });
        if (filtered.length > 0) {
            field = filtered[0];
        }

        if (field) {
            var namespacedName = this.getFieldName(field);
            var node = _reactDom2['default'].findDOMNode(this.refs[namespacedName]);
            if (node) {
                if (node.type === 'checkbox') {
                    value = node.checked;
                } else {
                    value = node.value;
                }
            }
        }
        return value;
    },
    renderHiddenFields: function renderHiddenFields() {

        var hiddenFields = [];
        var k;
        var v;
        var t;
        var field;

        // Render hidden input fields
        // FIXME: calling "in" operator on array. This will break with es5 shims (CC)
        for (k in this.props.fields) {
            field = this.props.fields[k];
            if (field && field.options.is_hidden) {
                v = this.getFieldValue(field);
                t = parseInt(Math.random() * Math.pow(10, 6), 10);
                hiddenFields.push(_react2['default'].createElement(FormHiddenField, { key: 'hidden-field-' + t, name: this.getFieldName(field), value: v }));
            }
        }

        return hiddenFields;
    },
    renderCsrfField: function renderCsrfField() {

        var k;
        var v;
        var field;

        // FIXME: calling "in" operator on array. This will break with es5 shims (CC)
        for (k in this.props.fields) {
            field = this.props.fields[k];
            if (field && field.name === _hfReactHelper2['default'].HfConstants.csrfFieldName) {
                v = this.getFieldValue(field);
                return _react2['default'].createElement(FormHiddenField, { name: this.getFieldName(field), value: v });
            }
        }
    },
    renderField: function renderField(name, attributes) {
        if (this.props.fields) {

            var field;
            var k;

            for (k in this.props.fields) {
                if (this.props.fields[k] && this.props.fields[k].name === name) {
                    field = this.props.fields[k];
                    break;
                }
            }

            if (field) {

                if (field.attributes) {
                    // Rewrite some of the attributes to deal with React
                    for (k in field.attributes) {
                        if (k === 'class') {
                            field.attributes.className = field.attributes['class'];
                            delete field.attributes['class'];
                        }
                    }
                }

                var v = this.getFieldValue(field);

                return _react2['default'].createElement(FormField, {
                    name: this.getFieldName(field),
                    ref: this.getFieldName(field),
                    type: field.type,
                    value: v,
                    options: field.options,
                    attributes: attributes });
            }
        }
    },
    renderErrorText: function renderErrorText() {
        if (this.state.errors) {
            if (this.state.errors.global) {
                return _react2['default'].createElement(
                    'p',
                    null,
                    this.state.errors.global
                );
            } else if (this.state.errors.named) {
                var errs = [];
                for (var k in this.state.errors.named) {
                    if (this.state.errors.named[k]) {
                        errs.push(_react2['default'].createElement(
                            'p',
                            { key: 'error-' + k },
                            this.state.errors.named[k]
                        ));
                    }
                }
                return errs;
            }
        }
    },
    renderFormTag: function renderFormTag(formContent) {
        return _react2['default'].createElement(
            'form',
            { name: this.props.name, method: this.props.method, action: this.props.action },
            formContent
        );
    },
    getFormData: function getFormData() {
        // Should be implemented by the actual form component
        return null;
    },
    submitAsync: function submitAsync(okCallback, errCallback) {

        var data = this.getFormData();

        if (data === null) {
            data = {};
            $('input, select, textarea', _reactDom2['default'].findDOMNode(this)).each(function () {
                var el = $(this);
                var name = el.attr('name');
                if (name) {
                    if (el.attr('type') === 'checkbox') {
                        var isChecked = false;
                        if (typeof el.prop === 'function') {
                            if (el.prop('checked')) {
                                isChecked = true;
                            }
                        } else if (el.attr('checked') === 'checked' || el.attr('checked') === true) {
                            isChecked = true;
                        }
                        data[name] = isChecked;
                    } else {
                        data[name] = el.val();
                    }
                }
            });
        }

        $.ajax({
            'context': this,
            'url': this.props.action,
            'type': this.props.method || 'POST',
            'dataType': 'json',
            'data': data,
            'success': okCallback,
            'error': errCallback
        });
    }
};

exports.createFormClass = function () {
    var specs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    // Copy to prevent the original from being altered
    var baseSpecs = (0, _lodash.extend)({}, BaseFormSpecs);

    if (specs.getInitialState) {
        var baseGetInitialStates = baseSpecs.getInitialState;
        var extGetInitialStates = specs.getInitialState;
        specs.getInitialState = function () {
            var baseStates = baseGetInitialStates.call(this);
            var extStates = extGetInitialStates.call(this);
            return (0, _lodash.extend)(baseStates, extStates);
        };
    }

    if (specs.propTypes) {
        var basePropTypes = (0, _lodash.extend)({}, baseSpecs.propTypes); // Copy
        specs.propTypes = (0, _lodash.extend)(basePropTypes, specs.propTypes);
    }

    var comp = _react2['default'].createClass((0, _lodash.extend)(baseSpecs, specs));

    return comp;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/base-form.jsx
 ** module id = 703
 ** module chunks = 0 1
 **/